<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Individual Risk</div>
        <div>
          <bread-crumb :bread-crumbs="['Individual Risk']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <RiskStandardInd />
      <v-card-text>
        <v-card-title>
          <v-row class="ms-1">
            <v-dialog
              persistent
              max-width="400px"
              v-model="dialog"
              @click="onClickBack()"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-row class="mt-0">
                  <v-col cols="12" md="3" class="mb-2">
                    <v-btn
                      depressed
                      color="primary"
                      dark
                      class="me-3 text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                      small
                      @click="openDialog()"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >
                      Add Parameter
                    </v-btn>
                    <v-btn
                      depressed
                      @click="downloadExcelsheet"
                      color="primary"
                      small
                      ><v-icon small>mdi-file-excel-outline</v-icon>Export
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="4">
                    <v-text-field
                      append-icon="mdi-magnify"
                      label="Type here to filter the table data."
                      hide-details
                      class="me-4"
                      dense
                      v-model="search"
                      single-line
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>

              <v-card height="">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-toolbar color="secondary" dark flat dense>
                    <span class="subtitleFontsize">Complinace Parameter</span
                    ><v-spacer></v-spacer>
                    <v-btn depressed icon @click="onClickBack()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text class="my-5">
                    <v-row>
                      <!-- <v-col cols="12" md="12">
                        <label class="my-0 rounded labelFontsize required">
                          Parameter Type
                        </label>
                        <v-autocomplete
                          dense
                          class="rounded"
                          outlined
                          placeholder="Parameter Type"
                          :rules="parameter_Type"
                          item-text="text"
                          item-value="value"
                          v-model="complianceParaDetails.parameter_type"
                          :items="parmeterType"
                          @change="
                            getparameterRisk(
                              complianceParaDetails.parameter_type
                            )
                          "
                        >
                        </v-autocomplete>
                      </v-col> -->
                      <v-col cols="12" md="12">
                        <label class="my-0 rounded labelFontsize required">
                          Risk Factor
                        </label>
                        <v-autocomplete
                          dense
                          class="rounded"
                          outlined
                          item-text="text"
                          item-value="value"
                          placeholder="Risk Factor"
                          :rules="Risk_Factor"
                          v-model="complianceParaDetails.risk_factor"
                          :items="parameterList"
                          @change="
                            getparameterlist(complianceParaDetails.risk_factor)
                          "
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12">
                        <label class="my-0 labelFontsize required">
                          Parameter
                        </label>
                        <v-autocomplete
                          placeholder="Parameter"
                          dense
                          class="rounded"
                          outlined
                          item-text="text"
                          item-value="value"
                          :rules="parameter"
                          v-model="complianceParaDetails.parameter"
                          :items="parametervalueList"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12">
                        <label class="my-0 labelFontsize required">
                          Weight
                        </label>
                        <v-text-field
                          placeholder="Weight"
                          dense
                          class="rounded"
                          outlined
                          type="number"
                          hide-spin-buttons
                          @keydown="filterNumberInput"
                          v-model="complianceParaDetails.weight"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <div class="d-flex me-5 justify-end pb-3">
                    <v-btn
                      depressed
                      small
                      color="primary"
                      min-width="175px"
                      @click="saveData"
                      v-if="!selcteditemId"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >
                      Add
                    </v-btn>
                    <v-btn
                      depressed
                      small
                      outlined
                      color="primary"
                      min-width="175px"
                      class="ms-2 text-capitalize"
                      @click="onClickBack({})"
                      v-if="!selcteditemId"
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >
                      Cancel
                    </v-btn>

                    <v-btn
                      depressed
                      small
                      v-if="selcteditemId"
                      color="primary"
                      min-width="175px"
                      @click="updateRiskParameter()"
                      class="text-capitalize"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-edit-outline</v-icon
                      >
                      Update
                    </v-btn>
                    <v-btn
                      depressed
                      small
                      outlined
                      color="primary"
                      min-width="175px"
                      @click="onClickBack()"
                      class="ms-2 text-capitalize"
                      v-if="selcteditemId"
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >Cancel
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </v-card-title>

        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="AllValuescores"
          :search="search"
          show-group-by
          group-by="risk_factor.value"
          dense
          class="p-1"
        >
          <template v-slot:group.header="{ group, headers, toggle }">
            <td :colspan="headers.length" @click="toggle">
              <span class="mx-5 font-weight-bold">{{ group }}</span>
              <!-- <v-btn @click="toggle" x-small icon :ref="group">
                <v-icon v-if="isOpen">mdi-chevron-up-circle-outline</v-icon>
                <v-icon v-else>mdi-chevron-down-circle-outline</v-icon>
              </v-btn> -->
            </td>
          </template>
          <template v-slot:item.is_active="{ item }">
            <div class="d-flex">
              <v-btn icon @click="editItem(item)">
                <v-icon color="primary" small>
                  mdi-content-save-edit-outline
                </v-icon>
              </v-btn>
              <v-switch
                v-model="item.is_active"
                height="0px"
                color="success"
                dense
                @change="isactiveupdate(item)"
              ></v-switch>

              <v-icon class="mr-2" @click="nextroute(item)">
                mdi-chevron-right-circle
              </v-icon>
            </div>
          </template>
        </v-data-table>
        <OverlayPageVue :showOverlay="loaderOverlay" />
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import RiskStandardInd from "./RiskStandardInd.vue";
import alerts from "@/mixins/alerts";
import { complianceIND } from "@/utils/validationCopy.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
export default {
  name: "Individual Risk",
  mixins: [alerts],
  components: {
    BreadCrumb,
    RiskStandardInd,
    OverlayPageVue,
  },
  data: () => ({
    filterNumberInput,
    ...complianceIND,
    selcteditemId: "",
    parameterList: [],
    parametervalueList: [],
    selectededititem: null,
    dialog: false,
    loader: false,
    loaderOverlay: false,
    valid: true,
    search: "",
    editedIndex: -1,
    headers: [
      {
        text: "ID",
        value: "id",
        groupable: false,
      },
      {
        text: "Risk Factor ",
        align: "start",
        value: "risk_factor.value",
        groupable: false,
      },
      // {
      //   text: "Parameter Type",
      //   value: "parameter_type.value",
      //   groupable: false,
      // },
      { text: "Parameter", value: "parameter.value", groupable: false },
      { text: "Weight", value: "weight", groupable: false },
      { text: "Active", value: "is_active", groupable: false },
    ],
    AllValuescores: [],
    RiskFactors: [],
    parmeterType: [],
    parameterFactors: [],
    complianceParaDetails: {
      parameter: "",
      parameter_type: "ITR",
      risk_factor: "",
      description: "",
      type: "IND",
      weight: "",
    },
    defaultItem: {
      parameter: "",
      parameter_type: "ITR",
      risk_factor: "",
      description: "",
      type: "IND",
      weight: "",
    },
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Parameter" : "Edit Parameter";
    },
  },

  watch: {
    dialog(val) {
      val || this.onClickBack();
    },
  },
  mounted() {
    this.getallValueScores();
    this.getparameterRisk(this.complianceParaDetails.parameter_type);
    // this.getRiskfactor();
    // this.getallParameters();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.AllValuescores.length) {
        await this.exportToExcel(this.headers, this.AllValuescores, "Individual Risk");
      }
    },
    nextroute(item) {
      this.$router.push({
        name: "Compliance IND Value",
        query: {
          data: JSON.stringify({
            risk_factor: item.risk_factor,
            id: item.id,
            parameter: item.parameter,
            weight: item.weight,
          }),
        },
      });
    },
    async getparameterRisk(code) {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          this.parameterList = response.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
          if (this.complianceParaDetails.risk_factor) {
            this.getparameterlist(this.complianceParaDetails.risk_factor);
          }
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.parameterList = [];
        //   this.returnNewToken();
        //   this.getparameterRisk();
        //   this.stoploader();
        // }
        else {
          this.parameterList == [];
          this.stoploader();
        }
      } catch (error) {
        this.parameterList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getparameterlist(code) {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          this.parametervalueList = response.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
          this.stoploader();
        }
        //  else if (response.data.status_code === 401) {
        //   this.parametervalueList = [];
        //   this.returnNewToken();
        //   this.getparameterlist();
        //   this.stoploader();
        // }
        else {
          this.parametervalueList = [];
          this.stoploader();
        }
      } catch (error) {
        this.parametervalueList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getparameterType() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns("RPT");
        if (response.data.status_code === 200) {
          this.parmeterType = response.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });

          this.stoploader();

          if (this.complianceParaDetails.parameter_type) {
            this.getparameterRisk(this.complianceParaDetails.parameter_type);
          }
        }
        // else if (response.data.status_code === 401) {
        //   this.parmeterType = [];
        //   this.returnNewToken();
        //   this.getparameterType();
        //   this.stoploader();
        // }
        else {
          this.parmeterType = [];
          this.stoploader();
        }
      } catch (error) {
        this.parmeterType = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getallValueScores() {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getValuescoresInd("IND");
        if (response.data.status_code === 200) {
          this.AllValuescores = response.data.data[0];
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.AllValuescores = [];
        //   this.returnNewToken();
        //   this.getallValueScores();
        //   this.stoploader();
        // }
        else {
          this.AllValuescores = [];
          this.stoploader();
        }
      } catch (error) {
        this.AllValuescores = [];
        this.stoploader();
        console.error(error);
      }
    },

    onClickBack() {
      this.dialog = false;
      this.resetValidation();
    },
    async saveData() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await setupService.PostINDParameter(
            this.complianceParaDetails
          );
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getallValueScores();
            setTimeout(() => {
              this.loaderOverlay = false;
            }, 400);
            this.onClickBack();
          }
          // else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.saveData();
          // }
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async updateRiskParameter() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await setupService.updateRiskParameter(
            this.selcteditemId,
            this.complianceParaDetails
          );
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(
              `Update parameter : ${responseData.data.message}`
            );
            this.getallValueScores();
            setTimeout(() => {
              this.loaderOverlay = false;
            }, 400);
            this.onClickBack();
          }
          //  else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.saveData();
          // }
          else {
            this.showAlertError(`Update Failed : ${responseData.data.message}`);
            this.loaderOverlay = false;
          }
        } catch (error) {
          this.onClickBack();
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
          this.loaderOverlay = false;
        }
      }
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    openDialog() {
      this.selcteditemId = "";
      this.dialog = true;
      this.resetValidation();
      this.getparameterType();
    },
    editItem(item) {
      console.log(item);
      this.dialog = true;
      if (item) {
        this.selcteditemId = item.id;
        this.complianceParaDetails.parameter_type =
          item.parameter_type.value_code;
        this.complianceParaDetails.parameter = item.parameter.value_code;
        this.complianceParaDetails.risk_factor = item.risk_factor.value_code;
        this.complianceParaDetails.weight = item.weight;
      }
      this.getparameterType();
    },
    async isactiveupdate(isactive) {
      console.log(isactive, "active");
      this.loaderOverlay = true;
      if (this.editedIndex < -1) {
        Object.assign(
          this.AllValuescores[this.editedIndex],
          this.complianceParaDetails
        );
      } else {
        console.log(
          "prameterdetails ",
          JSON.stringify(this.complianceParaDetails)
        );
        try {
          const responseData = await setupService.updateStatus(
            isactive.id,
            isactive.is_active
          );
          if (responseData && responseData.data.status_code == 200) {
            this.loaderOverlay = false;
            this.showAlertSuccess("Status is Updated", "success");
            this.getallValueScores();
          }
          //  else if (responseData.data.status_code == 401) {
          //   this.loader = false;
          //   this.returnNewToken();
          //   this.isactiveupdate(isactive);
          // }
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
  },
};
</script>
<style lang="css">
.required:after {
  content: " *";
  color: red;
}
</style>
